import type { Feature } from '@luna/gatekeeper';

export const reprintPin: Feature = {
    enabled: false,
    _description:
        'Displays reprint pin card in the card services section in the bank card settings page and credit card functions page',
};
